module.exports = __webpack_public_path__ + "static/media/innermanufacturing.308c59c9.jpg";